<template>
    <div class="datos-home mb-5" v-loading="loading.length > 0">
        <h3 class="mb-5">
            <img src="images/mini-logo.svg" width="20" alt="logo presupuesto abierto" class="img-fluid">
            Datos Sobre Presupuesto Abierto {{periodo}}</h3>
        <div class="row">
            <div class="col-md-4">
                <div class="media">
                    <img src="images/home-01.svg" alt="" class="mr-3">
                    <div class="media-body">
                        <div class="title mt-2">
                            servicios públicos involucrados
                        </div>
                        <div class="number">
                            {{numeral(institutions).format('0,0')}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-4 my-4 my-md-0">
                <div class="media">
                    <img src="images/home-02.svg" alt="" class="mr-3">
                    <div class="media-body">
                        <div class="title mt-2">
                            registros transaccionales
                        </div>
                        <div class="number">
                            {{numeral(records).format('0,0')}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="media">
                    <img src="images/home-03.svg" alt="" class="mr-3">
                    <div class="media-body">
                        <div class="title">
                            ppto total ejecutado a la fecha
                        </div>
                        <div class="number">
                            {{numeral(total).divide(1000000).format('0,0')}}
                            <div class="currency">Millones de pesos</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';
    import numeral from 'numeral';
    export default{
        data: function(){
            return {
                periodo: this.$store.state.defaultYear,
                loading: [],
                institutions: 0,
                records: 0,
                total: 0
            }
        },
        methods: {
            numeral: numeral,
            refreshData: function(){
                this.loading.push(true);
                axios.get('/api/v1/data/pagos',{
                    params: {
                        'where': {periodo: this.periodo},
                        'distinct': JSON.stringify(['partida','capitulo']),
                    }
                }).then(response => {
                    this.loading.pop();
                    this.institutions = response.data.length;
                }).catch(e => {
                    this.loading.pop();
                });

                this.loading.push(true);
                axios.get('/api/v1/data/pagos',{
                    params: {
                        'where': {periodo: this.periodo},
                        'count': true
                    }
                }).then(response => {
                    this.loading.pop();
                    this.records = response.data[0].count;
                }).catch(e => {
                    this.loading.pop();
                });

                this.loading.push(true);
                axios.get('/api/v1/data/pagos',{
                    params: {
                        'where': {periodo: this.periodo},
                        'sum': JSON.stringify('devengo')
                    }
                }).then(response => {
                    this.loading.pop();
                    this.total = response.data[0].sum;
                }).catch(e => {
                    this.loading.pop();
                })
            }
        },
        mounted: function(){
            this.refreshData();
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/Components/Visualizations/GlobalInfo.vue